var map = {
	"./pic1.png": 6735,
	"./pic2.png": 2244,
	"./pic3.png": 8925,
	"./pic4.png": 1026,
	"./pic5.png": 2155,
	"./pic6.png": 4512,
	"./pic7.png": 761,
	"./pic8.png": 5198,
	"./pic9.png": 4423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8539;